import { isEmpty } from 'lodash';
import { valuationsAction } from 'common/actions';
import { ValuationByAllocation } from 'common/types/valuation';
import { FundInvestmentPayload } from 'pages/FundInvestments';
import { parseFundInvestmentDetails } from 'pages/FundInvestments/utils/parseFundInvestmentDetails';
import { getNumberValue, getObjectValue, handleCatchError } from 'utilities';
import { SaveFundInvestmentMarketAdjustmentParams } from './saveFundInvestmentMarketAdjustment.types';

const saveFundInvestmentMarketAdjustment = async (params: SaveFundInvestmentMarketAdjustmentParams) => {
  const {
    cleanUnsavedChanges,
    currentAllocationId,
    currentMarketAdjustment,
    dispatch,
    fundInvestmentByAllocation,
    setArePendingChanges,
    updatedValutionMarketAdjustment,
    updateFundInvestmentDetails,
    updateValuation,
  } = params;

  try {
    // Save the updated valuation
    const valuationResponse = await updateValuation({
      valuation: updatedValutionMarketAdjustment,
    });
    const { valuation: updatedValuation } = getObjectValue(valuationResponse);

    // If no updated valuation was returned, abort further updates
    if (isEmpty(updatedValuation)) {
      return;
    }

    // Update store
    dispatch?.(valuationsAction?.setValuationInfo(updatedValuation as ValuationByAllocation));

    // Mark changes as not pending
    cleanUnsavedChanges();
    setArePendingChanges(false);
  } catch (error) {
    handleCatchError(error);
  }

  try {
    // Parse and update all fund investment details, preserving updated market adjustment
    const updatedFundInvestmentDetails = parseFundInvestmentDetails(fundInvestmentByAllocation).map(detail => ({
      ...detail,
      market_adjustment: currentMarketAdjustment?.market_adjustment,
    }));

    const updatedFundInvestment = {
      allocation: getNumberValue(currentAllocationId),
      deleted_investment_details: [],
      investment_details: updatedFundInvestmentDetails,
    } as FundInvestmentPayload;

    // Save the updated fund investment details
    await updateFundInvestmentDetails({
      fundInvestmentDetails: updatedFundInvestment,
    });
  } catch (error) {
    handleCatchError(error);
  }
};

export default saveFundInvestmentMarketAdjustment;
